import React from 'react';
import { Box, IconButton, Badge, Fade } from '@mui/material';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';

interface ChatToggleButtonProps {
  isOpen: boolean;
  unreadCount: number;
  hasNewMessages: boolean;
  onToggle: () => void;
}

const ChatToggleButton: React.FC<ChatToggleButtonProps> = ({
  isOpen,
  unreadCount,
  hasNewMessages,
  onToggle,
}) => {
  return (
    <Fade in={!isOpen} timeout={300}>
      <Box className="chat-toggle-button">
        <Badge
          badgeContent={unreadCount > 0 ? unreadCount : 0}
          color="error"
          max={99}
          invisible={unreadCount === 0}
          className="chat-notification-badge"
        >
          <IconButton
            onClick={onToggle}
            className={`chat-icon-button ${hasNewMessages ? 'has-new-messages' : ''}`}
            size="large"
          >
            <ChatBubbleIcon />
          </IconButton>
        </Badge>
      </Box>
    </Fade>
  );
};

export default ChatToggleButton;
